export const LIMIT_LEVEL_TYPE_SELECT = [
    'Phone',
    'Email',
    'Identity',
    'Address',
    'ProofOfDeposit',
    'JointCorporateAgreements',
    'WorldCheck'
];
